import { MdOutlineArrowBack, MdOutlineSearchOff } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../ui'
import { ShellMessage } from '../ShellMessage'

/** The `*` route inside the shell: react-admin's NotFound texts (ra-language-english). */
export function NotFound() {
  const navigate = useNavigate()
  return (
    <ShellMessage title="Not Found" icon={<MdOutlineSearchOff />}>
      <p>Either you typed a wrong URL, or you followed a bad link.</p>
      <p>
        <Button
          icon={<MdOutlineArrowBack />}
          onClick={() => {
            void navigate(-1)
          }}
        >
          Go Back
        </Button>
      </p>
    </ShellMessage>
  )
}
